export const toastConfig = {
  closeButton: true,
  timeOut: 3000,
  enableHtml: true,
  tapToDismiss: false,
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
  maxOpened: 5,
};
